"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var CollapseIcon = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "white", strokeWidth: "1" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 16 16", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("path", { d: "M4.44444 7.5C4.1683 7.5 3.94444 7.72386 3.94444 8C3.94444 8.27614 4.1683 8.5 4.44444 8.5H11.5556C11.8317 8.5 12.0556 8.27614 12.0556 8C12.0556 7.72386 11.8317 7.5 11.5556 7.5H4.44444ZM4.26667 0.5H11.7333C12.4883 0.5 13.0245 0.500389 13.4441 0.534671C13.8578 0.568475 14.114 0.632728 14.317 0.736153C14.7247 0.943878 15.0561 1.27534 15.2638 1.68302C15.3673 1.886 15.4315 2.14217 15.4653 2.55592C15.4996 2.97551 15.5 3.51168 15.5 4.26667V11.7333C15.5 12.4883 15.4996 13.0245 15.4653 13.4441C15.4315 13.8578 15.3673 14.114 15.2638 14.317C15.0561 14.7247 14.7247 15.0561 14.317 15.2638C14.114 15.3673 13.8578 15.4315 13.4441 15.4653C13.0245 15.4996 12.4883 15.5 11.7333 15.5H4.26667C3.51168 15.5 2.97551 15.4996 2.55592 15.4653C2.14217 15.4315 1.886 15.3673 1.68302 15.2638C1.27534 15.0561 0.943878 14.7247 0.736153 14.317C0.632728 14.114 0.568475 13.8578 0.534671 13.4441C0.500389 13.0245 0.5 12.4883 0.5 11.7333V4.26667C0.5 3.51168 0.500389 2.97551 0.534671 2.55592C0.568475 2.14217 0.632728 1.886 0.736153 1.68302C0.943878 1.27534 1.27534 0.943878 1.68302 0.736153C1.886 0.632728 2.14217 0.568475 2.55592 0.534671C2.97551 0.500389 3.51168 0.5 4.26667 0.5Z", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = CollapseIcon;
